import React, { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom';
import '../Header.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';

function BottomHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  // Close mobile menu when route changes
  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  // Close mobile menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      const mobileNav = document.querySelector('.mobile-nav');
      const menuIcon = document.querySelector('.menu-icon');
      
      if (mobileNav && menuOpen &&
          !mobileNav.contains(event.target) &&
          !menuIcon.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuOpen]);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  // Check if the current path matches the link path
  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <div className="bottom-header">
      <div className="container-fluid">
        <div className="bottom-header-content">
          {/* Menu Icon for mobile */}
          <div className="menu-icon" onClick={toggleMenu}>
            <FontAwesomeIcon icon={menuOpen ? faTimes : faBars} />
          </div>
          
          {/* Mobile Logo - Now positioned on the right */}
          <div className="mobile-logo">
            <a href="https://www.mundu-network.com/en/" className="logo-link">
              <img src='./Pics/Munduheader.png' alt="Company Logo" className="bottom-logo" />
            </a>
          </div>
          
          {/* Desktop Navigation - logo centered with links on sides */}
          <div className="desktop-nav">
            <div className="nav-container-new">
              {/* Left side links */}
              <div className="nav-left">
                <Link to="/" className={`nav-link ${isActive('/') ? 'active' : ''}`}>
                  <span className="link-text">Home</span>
                </Link>
                <Link to="/about" className={`nav-link ${isActive('/about') ? 'active' : ''}`}>
                  <span className="link-text">About Us</span>
                </Link>
                <Link to="/services" className={`nav-link ${isActive('/services') ? 'active' : ''}`}>
                  <span className="link-text">Services</span>
                </Link>
                <Link to="/team" className={`nav-link ${isActive('/team') ? 'active' : ''}`}>
                  <span className="link-text">Our Team</span>
                </Link>
              </div>
              
              {/* Right side links */}
              <div className="nav-right">
                <Link to="/why-choose-us" className={`nav-link ${isActive('/why-choose-us') ? 'active' : ''}`}>
                  <span className="link-text">Why Choose Us</span>
                </Link>
                <Link to="/ournetwork" className={`nav-link ${isActive('/ournetwork') ? 'active' : ''}`}>
                  <span className="link-text">Our Network</span>
                </Link>
                <Link to="/blog" className={`nav-link ${isActive('/blog') ? 'active' : ''}`}>
                  <span className="link-text">Blog</span>
                </Link>
                <Link to="/contact" className={`nav-link ${isActive('/contact') ? 'active' : ''}`}>
                  <span className="link-text">Contact us</span>
                </Link>
              </div>
              
              {/* Center logo */}
              <div className="nav-center">
                <a href="https://www.mundu-network.com/en/" className="logo-link">
                  <img src='./Pics/Munduheader.png' alt="Company Logo" className="bottom-logo" />
                </a>
              </div>
            </div>
          </div>
          
          {/* Mobile Navigation */}
          <div className={`mobile-nav ${menuOpen ? 'open' : ''}`}>
            <Link to="/" className={`nav-link ${isActive('/') ? 'active-mobile' : ''}`} onClick={toggleMenu}>
              <span className="link-text">Home</span>
            </Link>
            <Link to="/about" className={`nav-link ${isActive('/about') ? 'active-mobile' : ''}`} onClick={toggleMenu}>
              <span className="link-text">About Us</span>
            </Link>
            <Link to="/services" className={`nav-link ${isActive('/services') ? 'active-mobile' : ''}`} onClick={toggleMenu}>
              <span className="link-text">Services</span>
            </Link>
            <Link to="/team" className={`nav-link ${isActive('/team') ? 'active-mobile' : ''}`} onClick={toggleMenu}>
              <span className="link-text">Our Team</span>
            </Link>
            <Link to="/why-choose-us" className={`nav-link ${isActive('/why-choose-us') ? 'active-mobile' : ''}`} onClick={toggleMenu}>
              <span className="link-text">Why Choose Us</span>
            </Link>
            <Link to="/ournetwork" className={`nav-link ${isActive('/ournetwork') ? 'active-mobile' : ''}`} onClick={toggleMenu}>
              <span className="link-text">Our Network</span>
            </Link>
            <Link to="/blog" className={`nav-link ${isActive('/blog') ? 'active-mobile' : ''}`} onClick={toggleMenu}>
              <span className="link-text">Blog</span>
            </Link>
            <Link to="/contact" className={`nav-link ${isActive('/contact') ? 'active-mobile' : ''}`} onClick={toggleMenu}>
              <span className="link-text">Contact Us</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BottomHeader;
